import { render, staticRenderFns } from "./DeadlinesUpdatedLog.vue?vue&type=template&id=fe0b8e20"
import script from "./DeadlinesUpdatedLog.vue?vue&type=script&lang=js"
export * from "./DeadlinesUpdatedLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports